<template>
  <v-row>
    <v-col>
      <v-card
        :class="{
          'py-6 px-12': $vuetify.breakpoint.mdAndUp,
          'pa-5': $vuetify.breakpoint.smAndDown
        }"
        no-body
      >
        <div class="title">
          {{ title }}
        </div>

        <v-divider></v-divider>

        <div class="primary--text text--darken-2 px-1">
          * ใช้ในกรณีที่ต้องการยกเลิกวันลา โดยใบลานั้นมีการลาในระบบ
          และได้รับการอนุมัติการลาในระบบเรียบร้อยแล้ว
        </div>

        <v-form v-model="formValidate" ref="form">
          <v-container :class="{ 'pa-0': $vuetify.breakpoint.xsOnly }">
            <v-row>
              <v-col>
                <span class="px-1">
                  วันที่เขียน
                  {{ otherData.leaveAssignDateText }}
                </span>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="form.LeaveHead"
                  ref="LeaveHead"
                  label="เรียน"
                  hide-details="auto"
                  :rules="[rules.required]"
                  required
                  outlined
                  dense
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-select
                  v-model="form.ApproveLastLeaveOrderID"
                  ref="approveLastLeaveOrderID"
                  label="ใบลา"
                  hide-details="auto"
                  :rules="[rules.required]"
                  :items="leaveReferenceList"
                  required
                  outlined
                  dense
                  @change="onChangeLeaveOrderID"
                />
              </v-col>
            </v-row>

            <v-row v-if="form.ApproveLastLeaveOrderID">
              <v-col cols="12" class="py-1">
                <span class="px-1">จำนวนวันลา</span>
                <span class="title px-1" v-text="otherData.leaveAmountDay" />
                <span class="px-1" v-text="otherData.leaveDayName" />
              </v-col>
            </v-row>

            <v-row>
              <v-col />
            </v-row>

            <v-divider />

            <v-row>
              <v-col />
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="form.LeaveReason"
                  ref="LeaveReason"
                  label="เหตุผลการขอยกเลิก"
                  hide-details="auto"
                  :rules="[rules.required]"
                  required
                  outlined
                  dense
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-radio-group v-model="form.LeaveCancelType" row>
                  <v-radio label="ยกเลิกทั้งหมด" value="all" />
                  <v-radio
                    :label="`ยกเลิกตั้งแต่วันที่ ${beginDateText}`"
                    value="start"
                  />
                  <v-radio
                    :label="`ยกเลิกจนถึงวันที่ ${finishDateText}`"
                    value="end"
                  />
                </v-radio-group>
              </v-col>
            </v-row>

            <v-row v-if="form.LeaveCancelType != 'all'">
              <v-col cols="12">
                <table>
                  <tr>
                    <td class="font-weight-bold">วันที่</td>
                    <td class="font-weight-bold">ช่วงเช้า</td>
                    <td class="font-weight-bold">ช่วงบ่าย</td>
                  </tr>

                  <tr v-for="(item, index) in leaveCancelRange" :key="index">
                    <td class="pr-6">
                      {{ $dateFormatByLang(item.day, { format: 'D MMM YY' }) }}
                    </td>
                    <td>
                      <v-checkbox
                        v-model="leaveCancelSelect"
                        class="px-3 ma-0"
                        hide-details="auto"
                        :value="`${item.day}+am`"
                        :disabled="!item.am"
                        @click="onCheckDateRange({ day: item.day, type: 'am' })"
                      />
                    </td>
                    <td>
                      <v-checkbox
                        v-model="leaveCancelSelect"
                        class="px-3 ma-0"
                        hide-details="auto"
                        :value="`${item.day}+pm`"
                        :disabled="!item.pm"
                        @click="onCheckDateRange({ day: item.day, type: 'pm' })"
                      />
                    </td>
                  </tr>
                </table>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" class="py-1">
                <span class="px-1" v-text="leaveCancelDesc" />
              </v-col>
            </v-row>

            <v-row>
              <v-col />
            </v-row>

            <v-divider />

            <v-row>
              <v-col />
            </v-row>

            <leave-search-employee
              ref="leaveApprover"
              :selected-employee="form.EmployeeApproveID"
              :selected-employee-title="approverTitle"
              :selected-employee-name="otherData.employeeApprove[$lang]"
              :list="employeeApproveList"
              @search="onSearchEmpApprove"
              @select="onSelectApprover"
            />

            <v-row class="mt-4" align="center">
              <v-col cols="12">
                <v-btn
                  :color="isEditMode ? 'warning darken-1' : 'primary darken-2'"
                  depressed
                  large
                  @click="onSubmitForm()"
                  class="float-right"
                >
                  {{ isEditMode ? 'บันทึกการแก้ไข' : 'บันทึกข้อมูล' }}
                </v-btn>

                <v-btn
                  outlined
                  color="grey"
                  :to="`/leave/pending/${$guid}`"
                  depressed
                  large
                  class="float-right mr-1"
                >
                  ยกเลิก
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card>
    </v-col>
    <v-col cols="12">
      <v-dialog v-model="conDialogOnSubmitForm" max-width="500px">
        <v-card class="py-2">
          <v-card-title class="headline Black--text"
            >ยืนยันการบันทึกการลา</v-card-title
          >

          <v-card-text class="mb-2">
            <v-divider class="mb-2"></v-divider>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <div class="mr-4 mt-n8">
              <v-btn
                class="white--text mr-2"
                color="error"
                outlined
                @click="conDialogOnSubmitForm = false"
                >ยกเลิก
              </v-btn>
              <v-btn
                class="white--text mr-2"
                color="success"
                @click="conOnSubmitForm"
                >ยืนยัน
              </v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
    <v-col cols="12">
      <v-dialog v-model="loading1" hide-overlay persistent width="300">
        <v-card color="primary" dark>
          <v-card-text>
            กำลังบันทึก...
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card> </v-dialog
    ></v-col>
  </v-row>
</template>

<script>
import LeaveSearchEmployee from '@/components/leave/LeaveForm/LeaveSearchEmployee'

export default {
  components: {
    LeaveSearchEmployee
  },

  props: {
    title: {
      type: String,
      default: ''
    },

    type: {
      type: String,
      default: '20'
    }
  },

  data() {
    return {
      conDialogOnSubmitForm: false,
      loading1: false,
      loading: false,
      formValidate: null,
      ordainMenu: false,
      beginMenu: false,
      finishMenu: false,
      form: {},
      otherData: {
        docName: null,
        docFileName: null,
        leaveDayName: null,
        budgetYear: null,
        employeeApproveKeyword: '',
        employeeApprove: {
          ID: null,
          Tha: null,
          Eng: null
        },
        employeeName: {
          Tha: null,
          Eng: null
        },
        positionName: {
          Tha: null,
          Eng: null
        },
        orgNameAll: {
          Tha: null,
          Eng: null
        },
        leaveAssignDateText: null,
        leaveTypeName: null
      },
      leaveInfo: {},
      leaveReferenceList: [],
      employeeApproveList: [],
      leaveCancelSelect: [],
      leaveCancelRange: [],
      leaveCancelDesc: ''
    }
  },

  computed: {
    leaveOrderId() {
      return this.$route.params.leaveOrderId || '0'
    },

    beginDateText() {
      return this.$dateFormatByLang(this.otherData.leaveBeginDateOrigin, {
        format: 'DD MMMM YYYY',
        addUnit: 'Y',
        addValue: '543'
      })
    },

    finishDateText() {
      return this.$dateFormatByLang(this.otherData.leaveFinishDateOrigin, {
        format: 'DD MMMM YYYY',
        addUnit: 'Y',
        addValue: '543'
      })
    },

    rules() {
      return {
        required: v => !!v || 'กรุณากรอกข้อมูลช่องนี้'
      }
    },

    isEditMode() {
      return !!this.$route.params.leaveOrderId
    },

    approverTitle() {
      return 'ผู้บังคับบัญชา/ผู้ตรวจสอบการลา/ผู้อนุมัติการลา'
    }
  },

  watch: {
    otherData: {
      deep: true,
      handler() {
        this.$emit('updateOtherData', this.otherData)
      }
    },

    loading: {
      deep: true,
      handler() {
        this.$emit('updateLoading', this.loading)
      }
    },

    leaveCancelRange() {
      if (this.form.LeaveCancelType === 'all') this.onCheckDateRange()
      else this.leaveCancelSelect = []
    },

    'form.LeaveCancelType'() {
      this.onCheckDateRange()
      if (this.form.LeaveCancelType !== 'all') this.leaveCancelSelect = []
    }
  },

  async mounted() {
    this.leaveInfo = await this.apiGetLeaveInfo()
    //console.log(this.leaveInfo)
    this.intitialForm()
  },

  methods: {
    intitialForm() {
      this.form = {
        LeaveOrderID: this.leaveOrderId,
        EmployeeID: this.$guid,
        LeaveHead: this.leaveInfo.leaveHead || '',
        ApproveLastLeaveOrderID: this.leaveInfo.approveLastLeaveOrderID || '',
        LeaveReason: this.leaveInfo.leaveReason || '',
        LeaveCancelType: this.leaveInfo.leaveCancelType || 'all',
        CancelLeaveAmountDay: 0,
        EmployeeApproveID: this.leaveInfo.employeeApproveID || '',
        EmployeeApproveTypeID: 'Approve'
      }

      this.otherData = {
        docName: this.leaveInfo.docFileName || null,
        docFileName: null,
        leaveDayName: this.leaveInfo.leaveDayName || 'วัน',
        budgetYear:
          this.leaveInfo.budgetYear || new Date().toISOString().substr(0, 4),
        employeeApproveKeyword: '',
        employeeApprove: {
          ID: this.leaveInfo.employeeApproveNameID,
          Tha: this.leaveInfo.employeeApproveNameTha,
          Eng: this.leaveInfo.employeeApproveNameEng
        },
        employeeName: {
          Tha: this.leaveInfo.employeeNameTha,
          Eng: this.leaveInfo.employeeNameEng
        },
        positionName: {
          Tha: this.leaveInfo.positionNameTha,
          Eng: this.leaveInfo.positionNameEng
        },
        orgNameAll: {
          Tha: this.leaveInfo.orgNameAllTha,
          Eng: this.leaveInfo.orgNameAllEng
        },
        leaveBeginDateOrigin:
          this.$dateFormat(this.leaveInfo.leaveBeginDate) ||
          new Date().toISOString().substr(0, 10),
        leaveFinishDateOrigin:
          this.$dateFormat(this.leaveInfo.leaveFinishDate) ||
          this.$dateFormat(new Date().toISOString().substr(0, 10)),
        leaveAssignDateText: this.$dateFormatByLang(
          this.leaveInfo.leaveAssignDate
        ),
        leaveTypeName: this.leaveInfo.leaveTypeName,
        statLeaveTotal:
          parseFloat(this.form.StatLeaveLastDay) +
          parseFloat(this.form.StatLeaveNowDay),
        warningMessage: ''
      }

      this.leaveReferenceList = [
        ...this.leaveInfo.leaveReferenceList.map(item => {
          return {
            text: `${item.leaveOrderID} : ${item.leaveTypeName} 
          วันที่ ${this.$dateFormatByLang(item.leaveBeginDate)} 
          (${item.leaveBeginDayStatusID === 'PM' ? 'ช่วงบ่าย' : 'ช่วงเช้า'})
          - ${this.$dateFormatByLang(item.leaveFinishDate)} 
          (${item.leaveFinishDayStatusID === 'AM' ? 'ช่วงเช้า' : 'ช่วงบ่าย'})`,
            value: item.leaveOrderID,
            ...item
          }
        })
      ]

      if (this.leaveReferenceList.length > 0) {
        if (!this.leaveInfo.approveLastLeaveOrderID) {
          this.form.ApproveLastLeaveOrderID = this.leaveReferenceList[0].value
        }
        this.onChangeLeaveOrderID(this.leaveReferenceList[0].value)
      }

      this.onChangeDaySelection()
    },

    async onSearchEmpApprove(keyword) {
      this.otherData.employeeApproveKeyword = keyword
      if (this.otherData.employeeApproveKeyword.length > 2) {
        this.employeeApproveList = await this.apiPostSearchEmployeeByKeyword()
      }
    },

    onSelectApprover(item) {
      this.otherData.employeeApprove.ID = item.employeeID
      this.otherData.employeeApprove.Tha = item.employeeNameTha
      this.otherData.employeeApprove.Eng = item.employeeNameEng
      this.form.EmployeeApproveID = item.employeeID
    },

    onChangeLeaveOrderID(value) {
      const leaveInfo = this.leaveReferenceList.find(item => {
        return item.leaveOrderID === value
      })
      if (leaveInfo) {
        this.form.CancelLeaveAmountDay = leaveInfo.leaveAmountDay

        this.otherData.leaveAmountDay = leaveInfo.leaveAmountDay
        this.otherData.leaveBeginDateOrigin = this.$dateFormat(
          leaveInfo.leaveBeginDate
        )
        this.otherData.leaveFinishDateOrigin = this.$dateFormat(
          leaveInfo.leaveFinishDate
        )
        this.otherData.leaveBeginDayStatusID = leaveInfo.leaveBeginDayStatusID
        this.otherData.leaveFinishDayStatusID = leaveInfo.leaveFinishDayStatusID
      } else {
        // error handler
      }

      this.onUpdateLeaveRange()
    },

    async onChangeDaySelection() {
      const res = await this.apiPostComputeDay()
      const firstItem = res.length > 0 ? res[0] : null
      if (firstItem) {
        this.form.CancelLeaveAmountDay = firstItem.leaveAmountDay || 0
        this.otherData.budgetYear = firstItem.budgetYear
        this.otherData.leaveTypeName = firstItem.leaveTypeName
        this.otherData.statLeaveTotal =
          parseFloat(this.form.StatLeaveLastDay) +
          parseFloat(this.form.StatLeaveNowDay)
        this.otherData.warningMessage = firstItem.warningMessage
      }

      this.onUpdateLeaveRange()
    },

    onUpdateLeaveRange() {
      let range = []
      let day = this.otherData.leaveBeginDateOrigin
      let count = this.daydiff(
        this.otherData.leaveBeginDateOrigin,
        this.otherData.leaveFinishDateOrigin
      )
      for (let i = 0; i <= count; i++) {
        range.push({
          day: this.dayIncrease(day, i),
          am: true,
          pm: true
        })
      }

      if (this.otherData.leaveBeginDayStatusID === 'PM') {
        range[0].am = false
      }

      if (this.otherData.leaveFinishDayStatusID === 'AM') {
        range[range.length - 1].pm = false
      }

      this.leaveCancelRange = range

      this.onCheckDateRange()
    },

    onCheckDateRange(event) {
      let res = []
      let count = 0
      if (event) {
        if (this.form.LeaveCancelType === 'start') {
          count = this.daydiff(this.otherData.leaveBeginDateOrigin, event.day)
          for (let i = 0; i <= count; i++) {
            if (i === 0) {
              if (
                ['ALL', 'AM'].includes(this.otherData.leaveBeginDayStatusID)
              ) {
                res.push(
                  this.dayIncrease(this.otherData.leaveBeginDateOrigin, i) +
                    '+am'
                )
              }
              if (
                count > 0 ||
                (['ALL', 'PM'].includes(this.otherData.leaveBeginDayStatusID) &&
                  event.type === 'pm')
              ) {
                res.push(
                  this.dayIncrease(this.otherData.leaveBeginDateOrigin, i) +
                    '+pm'
                )
              }
            } else if (i === count) {
              res.push(
                this.dayIncrease(this.otherData.leaveBeginDateOrigin, i) + '+am'
              )
              if (event.type === 'pm') {
                res.push(
                  this.dayIncrease(this.otherData.leaveBeginDateOrigin, i) +
                    '+pm'
                )
              }
            } else {
              res.push(
                this.dayIncrease(this.otherData.leaveBeginDateOrigin, i) + '+am'
              )
              res.push(
                this.dayIncrease(this.otherData.leaveBeginDateOrigin, i) + '+pm'
              )
            }
          }
        }
        if (this.form.LeaveCancelType === 'end') {
          count = this.daydiff(event.day, this.otherData.leaveFinishDateOrigin)
          for (let i = 0; i <= count; i++) {
            if (i === 0) {
              if (event.type === 'am') {
                res.push(this.dayIncrease(event.day, i) + '+am')
              }
              if (
                count > 0 ||
                ['ALL', 'PM'].includes(this.otherData.leaveFinishDayStatusID)
              ) {
                res.push(this.dayIncrease(event.day, i) + '+pm')
              }
            } else if (i === count) {
              res.push(this.dayIncrease(event.day, i) + '+am')

              if (
                ['ALL', 'PM'].includes(this.otherData.leaveFinishDayStatusID)
              ) {
                res.push(this.dayIncrease(event.day, i) + '+pm')
              }
            } else {
              res.push(this.dayIncrease(event.day, i) + '+am')
              res.push(this.dayIncrease(event.day, i) + '+pm')
            }
          }
        }
        if (this.form.LeaveCancelType === 'all') {
          count = this.daydiff(
            this.otherData.leaveBeginDateOrigin,
            this.otherData.leaveFinishDateOrigin
          )
          for (let i = 0; i <= count; i++) {
            if (i === 0) {
              if (
                ['ALL', 'AM'].includes(this.otherData.leaveBeginDayStatusID)
              ) {
                res.push(
                  this.dayIncrease(this.otherData.leaveBeginDateOrigin, i) +
                    '+am'
                )
              }
              if (
                ['ALL', 'PM'].includes(this.otherData.leaveBeginDayStatusID)
              ) {
                res.push(
                  this.dayIncrease(this.otherData.leaveBeginDateOrigin, i) +
                    '+pm'
                )
              }
            } else if (i === count) {
              if (
                ['ALL', 'AM'].includes(this.otherData.leaveFinishDayStatusID)
              ) {
                res.push(
                  this.dayIncrease(this.otherData.leaveBeginDateOrigin, i) +
                    '+am'
                )
              }
              if (
                ['ALL', 'PM'].includes(this.otherData.leaveFinishDayStatusID)
              ) {
                res.push(
                  this.dayIncrease(this.otherData.leaveBeginDateOrigin, i) +
                    '+pm'
                )
              }
            } else {
              res.push(
                this.dayIncrease(this.otherData.leaveBeginDateOrigin, i) + '+am'
              )
              res.push(
                this.dayIncrease(this.otherData.leaveBeginDateOrigin, i) + '+pm'
              )
            }
          }
        }
        const [startDate, startType] = res[0].split('+')
        const [endDate, endType] = res[res.length - 1].split('+')

        this.leaveCancelDesc = this.$concat([
          'ยกเลิกการลาตั้งแต่วันที่',
          this.$dateFormatByLang(startDate),
          startType === 'pm' ? '(ช่วงบ่าย)' : '(ช่วงเช้า)',
          'ถึงวันที่',
          this.$dateFormatByLang(endDate),
          endType === 'am' ? '(ช่วงเช้า)' : '(ช่วงบ่าย)'
        ])
      } else {
        if (this.form.LeaveCancelType === 'all') {
          count = this.daydiff(
            this.otherData.leaveBeginDateOrigin,
            this.otherData.leaveFinishDateOrigin
          )
          for (let i = 0; i <= count; i++) {
            if (i === 0) {
              if (
                ['ALL', 'AM'].includes(this.otherData.leaveBeginDayStatusID)
              ) {
                res.push(
                  this.dayIncrease(this.otherData.leaveBeginDateOrigin, i) +
                    '+am'
                )
              }
              if (
                ['ALL', 'PM'].includes(this.otherData.leaveBeginDayStatusID)
              ) {
                res.push(
                  this.dayIncrease(this.otherData.leaveBeginDateOrigin, i) +
                    '+pm'
                )
              }
            } else if (i === count) {
              if (
                ['ALL', 'AM'].includes(this.otherData.leaveFinishDayStatusID)
              ) {
                res.push(
                  this.dayIncrease(this.otherData.leaveBeginDateOrigin, i) +
                    '+am'
                )
              }
              if (
                ['ALL', 'PM'].includes(this.otherData.leaveFinishDayStatusID)
              ) {
                res.push(
                  this.dayIncrease(this.otherData.leaveBeginDateOrigin, i) +
                    '+pm'
                )
              }
            } else {
              res.push(
                this.dayIncrease(this.otherData.leaveBeginDateOrigin, i) + '+am'
              )
              res.push(
                this.dayIncrease(this.otherData.leaveBeginDateOrigin, i) + '+pm'
              )
            }
          }

          this.leaveCancelDesc = this.$concat([
            'ยกเลิกการลาตั้งแต่วันที่',
            this.$dateFormatByLang(this.otherData.leaveBeginDateOrigin),
            this.otherData.leaveBeginDayStatusID === 'PM'
              ? '(ช่วงบ่าย)'
              : '(ช่วงเช้า)',
            'ถึงวันที่',
            this.$dateFormatByLang(this.otherData.leaveFinishDateOrigin),
            this.otherData.leaveFinishDayStatusID === 'AM'
              ? '(ช่วงเช้า)'
              : '(ช่วงบ่าย)'
          ])
        } else {
          res = []
          this.leaveCancelDesc = this.$concat([
            'ยกเลิกการลาตั้งแต่วันที่',
            '???',
            'ถึงวันที่',
            '???'
          ])
        }
      }

      this.leaveCancelSelect = res
    },

    async onSubmitForm() {
      if (
        this.$refs.form.validate() &&
        this.form.EmployeeApproveID &&
        this.leaveCancelSelect.length > 0
      ) {
        this.conDialogOnSubmitForm = true
      } else {
        let element = 'LeaveHead'
        if (!this.form.LeaveHead) {
          element = 'LeaveHead'
        } else if (!this.form.LeaveReason) {
          element = 'LeaveReason'
        } else {
          element = 'LeaveApprover'
        }
        this.$vuetify.goTo(this.$refs[element], { offset: 20 })
      }
    },
    async conOnSubmitForm() {
      this.conDialogOnSubmitForm = false
      this.loading1 = true
      try {
        const res = await this.apiPostCreateCommonLeave()
        if (res) {
          this.$router.push('/leave/pending/' + this.$guid)
        }
      } catch (e) {
        console.log(e.response || e)
      }
    },
    async apiGetLeaveInfo() {
      this.loading = true
      let body = {
        employeeId: this.$guid,
        leaveOrderId: this.leaveOrderId,
        leaveType: this.type
      }
      const action = 'leave/getCancelInfo'

      try {
        const res = await this.$store.dispatch(action, body)
        return res.data?.data[0] || {}
      } catch (e) {
        console.log(e.response || e)
      } finally {
        this.loading = false
      }
    },

    async apiPostSearchEmployeeByKeyword() {
      this.loading = true
      const body = {
        Keyword: this.otherData.employeeApproveKeyword
      }
      try {
        const res = await this.$store.dispatch(
          'leave/postSearchEmployeeByKeyword',
          body
        )
        return res.data?.data || []
      } catch (e) {
        console.log(e.response || e)
      } finally {
        this.loading = false
      }
    },

    async apiPostComputeDay() {
      this.loading = true
      const body = {
        ApproveLastLeaveOrderID: this.form.ApproveLastLeaveOrderID,
        LeaveBeginDate: this.otherData.leaveBeginDateOrigin,
        LeaveFinishDate: this.otherData.leaveFinishDateOrigin
      }
      try {
        const res = await this.$store.dispatch(
          'leave/postComputeDayForCancel',
          body
        )
        return res.data?.data || []
      } catch (e) {
        console.log(e.response || e)
      } finally {
        this.loading = false
      }
    },

    async apiPostCreateCommonLeave() {
      this.loading = true
      try {
        const cancelLastIndex = this.leaveCancelSelect.length - 1
        this.form.LeaveBeginDate = this.leaveCancelSelect[0].split('+')[0]
        this.form.LeaveFinishDate = this.leaveCancelSelect[
          cancelLastIndex
        ].split('+')[0]
        if (this.leaveCancelSelect.length > 1) {
          const cancelList = this.leaveCancelSelect.map(item => {
            const split = item.split('+')
            return {
              day: split[0],
              type: split[1]
            }
          })
          if (cancelList[0].day === cancelList[1].day) {
            this.form.LeaveBeginDayStatusID = 'ALL'
          } else {
            this.form.LeaveBeginDayStatusID = 'PM'
          }

          if (
            cancelList[cancelLastIndex - 1].day ===
            cancelList[cancelLastIndex].day
          ) {
            this.form.LeaveFinishDayStatusID = 'ALL'
          } else {
            this.form.LeaveFinishDayStatusID = 'AM'
          }
        } else {
          this.form.LeaveBeginDayStatusID = this.leaveCancelSelect[0]
            .split('+')[1]
            .toUpperCase()
          this.form.LeaveFinishDayStatusID = this.leaveCancelSelect[0]
            .split('+')[1]
            .toUpperCase()
        }

        let formData = new FormData()
        let formStringConverted = {}
        for (const [key, value] of Object.entries(this.form)) {
          // console.log(`${key} : ${value}`)
          if (typeof value === 'boolean') {
            formStringConverted[key] = value ? 'true' : 'false'
          } else if (typeof value === 'number') {
            formStringConverted[key] = value.toString()
          } else {
            formStringConverted[key] = value ? value.toString() : ''
          }
        }
        // console.log(formStringConverted)

        if (this.otherData.docFileName) {
          formData.append('filename1', this.otherData.docFileName)
        }
        formData.append('dataEform', JSON.stringify(formStringConverted))

        // for (let pair of formData.entries()) {
        //   console.log(pair[0] + ', ' + pair[1])
        // }

        const res = await this.$store.dispatch(
          'leave/postCreateCancelLeave',
          formData
        )
        return res.data?.data || []
      } catch (e) {
        console.log(e.response || e)
      } finally {
        this.loading = false
      }
    },

    daydiff(start, end) {
      return Math.ceil(Math.abs(this.$dateDiff(start, end)))
    },

    dayIncrease(date, increase) {
      return this.$dateFormat(date, {
        addUnit: 'd',
        addValue: parseInt(increase)
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>
